import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/images/logo/iknowa-sidenav-logo.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "tw-w-[25px] tw-h-[25px] tw-absolute tw-right-[12px] tw-top-[12px] tw-bg-[#FFA500] tw-rounded-full tw-flex tw-items-center tw-justify-center"
}
const _hoisted_7 = { class: "side_footer app-drawer__footer" }
const _hoisted_8 = { class: "footer-logo" }
const _hoisted_9 = { class: "tw-w-full tw-pt-4 tw-box-border tw-border-t-dashed-custom" }
const _hoisted_10 = {
  key: 1,
  class: "dashboard-verify-profile__info common-profile-view sidebar_profile !tw-p-0"
}
const _hoisted_11 = { class: "img-wrap" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-box-border tw-border-t-dashed-custom tw-flex tw-items-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-object-contain tw-my-[20px] tw-ml-0 tw-mr-auto",
    width: 160,
    "aspect-ratio": "16/9",
    cover: "",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_PageRestrictionNoticeModal = _resolveComponent("PageRestrictionNoticeModal")!
  const _component_CreateWorkstationModal = _resolveComponent("CreateWorkstationModal")!
  const _component_CommingSoonNoticeModal = _resolveComponent("CommingSoonNoticeModal")!
  const _component_SubmitVerificationNoticeModal = _resolveComponent("SubmitVerificationNoticeModal")!
  const _component_FreezeInsuranceExpired = _resolveComponent("FreezeInsuranceExpired")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_PropertyOwnerWorkStationModal = _resolveComponent("PropertyOwnerWorkStationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_navigation_drawer, {
              modelValue: $setup.drawer,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.drawer) = $event)),
              rail: $setup.rail,
              permanent: "",
              class: _normalizeClass(["sidebar_nav app-drawer", {
          'app-drawer__active': $setup.rail,
          'rxl:!tw-w-0': $setup.isUserWorkstationIsDefault,
          'rxl:!tw-w-[300px]':
            !$setup.isUserWorkstationIsDefault && !$setup.isWorkstationLoading && !$setup.rail,
          'rlg:!tw-bg-[transparent]': $setup.isShowTransparentColor,
        }]),
              width: "300",
              id: "navigationDrawer"
            }, {
              default: _withCtx(() => [
                (!$setup.isMobileView)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      icon: !$setup.rail ? 'mdi-menu-left' : 'mdi-menu-right',
                      variant: "text",
                      onClick: _withModifiers($setup.onClickExpand, ["stop"]),
                      class: _normalizeClass(["app-drawer__button", [{ side_btn_open: !$setup.rail, side_btn_close: $setup.rail }]])
                    }, null, 8, ["icon", "onClick", "class"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_icon, {
                  icon: "mdi-close",
                  class: "tw-absolute tw-right-4 tw-top-4 rmd:tw-hidden"
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(["tw-h-[64px] tw-w-full tw-overflow-hidden tw-mt-[2.1rem] tw-mb-[2.5rem] tw-rounded-[4px] tw-bg-[#EEF1F3] tw-border-b-[1px] tw-border-b-[#DFDFDF] tw-border-b-solid lg:!tw-mt-[2.5rem]", { '!tw-h-[55px] !tw-mt-[2.5rem]': $setup.rail }])
                }, [
                  ($setup.userWorkStationBanner)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.userWorkStationBanner,
                        class: "tw-w-full tw-h-full tw-object-cover",
                        alt: ""
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                        key: 1,
                        isRounded: false,
                        desktopFontSizeBig: true
                      }))
                ], 2),
                ($setup.sideBarTabList.length)
                  ? (_openBlock(), _createBlock(_component_v_list, {
                      key: 1,
                      density: "compact",
                      nav: "",
                      class: "side_nav app-drawer__list no-scroll"
                    }, {
                      default: _withCtx(() => [
                        ($setup.activeUserWorkstation?.isNWGContractor)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              class: "app-drawer__list-item tw-relative nwg_list__wrapper",
                              title: $setup.isNWGDashBoard ? 'Back To Iknowa' : 'Go TO NWG Dashboard',
                              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickNWGFlow()))
                            }, {
                              prepend: _withCtx(() => [
                                ($setup.isNWGDashBoard)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: require('../../assets/icons/cheveron-left.svg'),
                                      alt: "icon"
                                    }, null, 8, _hoisted_2))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: require('@/assets/icons/chevron-right.svg'),
                                      alt: "icon"
                                    }, null, 8, _hoisted_3))
                              ]),
                              _: 1
                            }, 8, ["title"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sideBarTabList, (tabItem, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: index,
                            class: _normalizeClass(["app-drawer__list-item tw-relative", {
                active: $setup.changeSidebarIcon.includes(tabItem.name),
                disable: $setup.checkIsModuleAllowedUser(tabItem.name),
              }]),
                            color: "#3366FF",
                            title: tabItem.name,
                            value: tabItem.name,
                            active: tabItem.route === $setup.selectedModule,
                            onClick: ($event: any) => ($setup.onClickModule(tabItem.route, tabItem.name))
                          }, {
                            prepend: _withCtx(() => [
                              ($setup.rail)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    bottom: ""
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      (tabItem.icon)
                                        ? (_openBlock(), _createElementBlock("img", _mergeProps({
                                            key: 0,
                                            src: 
                        require('@/assets/icons/sidebar-icons/' +
                          tabItem.icon +
                          '.svg')
                      ,
                                            alt: "icon",
                                            ref_for: true
                                          }, props), null, 16, _hoisted_4))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(tabItem.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (!$setup.rail && tabItem.icon)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: 
                    require('@/assets/icons/sidebar-icons/' +
                      tabItem.icon +
                      '.svg')
                  ,
                                    alt: "icon"
                                  }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              (
                  tabItem.name === 'Chat' &&
                  $setup.membersUnreadMsgCount +
                    $setup.groupsUnreadMsgCount +
                    $setup.projectsUnreadMsgCount +
                    $setup.workStationUnreadMsgCount >
                    0
                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(_component_Text, {
                                      textColor: "#fff",
                                      variant: "span",
                                      lineHeight: "0",
                                      textWeight: "400"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.membersUnreadMsgCount +
                    $setup.groupsUnreadMsgCount +
                    $setup.projectsUnreadMsgCount +
                    $setup.workStationUnreadMsgCount), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["title", "value", "active", "onClick", "class"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      ($setup.isWorkstationLoading)
                        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                            key: 0,
                            class: "tw-my-10",
                            type: "list-item-avatar"
                          }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              ($setup.userImage)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: $setup.userImage,
                                    width: "150",
                                    height: "150",
                                    alt: ""
                                  }, null, 8, _hoisted_12))
                                : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                                    key: 1,
                                    mobileFontSizeBig: true,
                                    desktopFontSizeMid: true,
                                    userName: `${$setup.user?.firstName} ${$setup.user?.lastName}`
                                  }, null, 8, ["userName"]))
                            ]),
                            (!$setup.rail)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  title: $setup.setUserName,
                                  nav: "",
                                  class: "profile_wrapper"
                                }, null, 8, ["title"]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _hoisted_13
                  ])
                ]),
                ($setup.createWorkstationRestrictionModal)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_14, "hello world"))
                  : _createCommentVNode("", true),
                ($setup.createWorkstationRestrictionModal)
                  ? (_openBlock(), _createBlock(_component_PageRestrictionNoticeModal, {
                      key: 3,
                      onOnClose: $setup.toggleRestrictionModal
                    }, null, 8, ["onOnClose"]))
                  : _createCommentVNode("", true),
                ($setup.isShowCreateWorkstationModal)
                  ? (_openBlock(), _createBlock(_component_CreateWorkstationModal, {
                      key: 4,
                      onOnClose: $setup.toggleCreateWorkstationModal
                    }, null, 8, ["onOnClose"]))
                  : _createCommentVNode("", true),
                ($setup.isShowComingSoonModal)
                  ? (_openBlock(), _createBlock(_component_CommingSoonNoticeModal, {
                      key: 5,
                      onOnClose: $setup.toggleComingSoonModal,
                      onOnRouteToDashboard: $setup.routeToDashboard,
                      onOnTutorial: $setup.toggleComingSoonModal
                    }, null, 8, ["onOnClose", "onOnRouteToDashboard", "onOnTutorial"]))
                  : _createCommentVNode("", true),
                ($setup.isShowingVerificationRequiredModal)
                  ? (_openBlock(), _createBlock(_component_SubmitVerificationNoticeModal, {
                      key: 6,
                      onOnClose: $setup.toggleSubmitVerificationModal,
                      onOnRouteToDashboard: $setup.routeToDashboard
                    }, null, 8, ["onOnClose", "onOnRouteToDashboard"]))
                  : _createCommentVNode("", true),
                (
            $setup.userInsurenceExperiedStatus &&
            $setup.isShowFreezeModal &&
            $setup.isWorkStationVerified &&
            !$setup.isUserProprtyOwner
          )
                  ? (_openBlock(), _createBlock(_component_FreezeInsuranceExpired, {
                      key: 7,
                      onOnClose: $setup.onCloseFreezeModal
                    }, null, 8, ["onOnClose"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "rail", "class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    ($setup.isShowPropertyOwnerWorkStationModal)
      ? (_openBlock(), _createBlock(_component_PropertyOwnerWorkStationModal, {
          key: 0,
          onOnClickCloseTab: $setup.onClickClosePOWorkstationModal
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}